import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=442fa221&scoped=true&"
import script from "./userSettings.vue?vue&type=script&lang=js&"
export * from "./userSettings.vue?vue&type=script&lang=js&"
import style0 from "./userSettings.vue?vue&type=style&index=0&id=442fa221&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442fa221",
  null
  
)

export default component.exports